var _rect, _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckFullGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#C8E9C5",
    fillOpacity: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_391_7568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.167 17.4998L21.3593 20.6358C20.2468 21.8785 19.6905 22.4998 18.9587 22.4998C18.2268 22.4998 17.6705 21.8785 16.558 20.6358L15.8337 19.8268M28.3337 19.9998C28.3337 24.6022 24.6027 28.3332 20.0003 28.3332C15.398 28.3332 11.667 24.6022 11.667 19.9998C11.667 15.3975 15.398 11.6665 20.0003 11.6665C24.6027 11.6665 28.3337 15.3975 28.3337 19.9998Z",
    stroke: "#4CB944",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_391_7568"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFullGreen);
export default __webpack_public_path__ + "static/media/check-full-green.146b14141da2a89a1ceceb83c1fb4133.svg";
export { ForwardRef as ReactComponent };